import ConfirmModalButton from './ConfirmModalButton';
import style from './confirm-modal.module.less';
import { Modal, ModalBlock } from '@sb1/ffe-modals-react';
import { Heading2 } from '@sb1/ffe-core-react';

const ConfirmModal = ({
    title,
    message,
    successText,
    secondaryText,
    cancelText,
    onClickSuccess,
    onClickSecondary,
    onClickCancel,
    useActionButton,
    modalRef,
}) => {
    const onCancel = () => {
        if (onClickCancel) onClickCancel();
        modalRef.current.close();
    };
    return (
        <Modal ref={modalRef} ariaLabelledby={'confirm-modal-title'} onClose={onCancel}>
            <ModalBlock>
                <Heading2 id="confirm-modal-title">{title}</Heading2>
                <div dangerouslySetInnerHTML={{ __html: message }} suppressHydrationWarning />
                <div className={style.buttonsContainer}>
                    {secondaryText ? (
                        <ConfirmModalButton title={secondaryText} type="cancel" onClick={onClickSecondary} />
                    ) : null}
                    {cancelText ? <ConfirmModalButton title={cancelText} type="cancel" onClick={onCancel} /> : null}
                    <ConfirmModalButton
                        title={successText}
                        type={useActionButton ? 'action' : 'success'}
                        onClick={onClickSuccess}
                    />
                </div>
            </ModalBlock>
        </Modal>
    );
};

export default ConfirmModal;
